import { useNavigate } from 'react-router-dom';
import { Button } from '@repo/ui/components/Button';
import {
  CardContent,
  CardDescription,
  CardHeader,
} from '@repo/ui/components/Card';
import { cn } from '@repo/ui/utils';

interface ErrorPageProps {
  title?: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}
const ErrorPage = ({ title, description, action }: ErrorPageProps) => {
  const navigate = useNavigate();

  const canGoBack = window.history.length > 1;

  return (
    <div
      id="error-page-card"
      className={cn(
        'flex',
        'min-h-full',
        'flex-col',
        'items-center',
        'justify-center'
      )}
    >
      <CardHeader>
        <h2 className={cn('text-lg', 'font-semibold')}>
          {title || 'Error 404'}
        </h2>
      </CardHeader>
      <CardContent
        className={cn('flex', 'flex-col', 'items-center', 'justify-center')}
      >
        <CardDescription>
          {description ||
            "We're sorry but the page you're looking for could not be found."}
        </CardDescription>
        <Button
          variant="default"
          className={cn('my-8')}
          onClick={
            action?.onClick ??
            (() => (canGoBack ? navigate(-1) : navigate('/')))
          }
        >
          {action?.label ?? (canGoBack ? 'Go back' : 'Go to start page')}
        </Button>
      </CardContent>
    </div>
  );
};

export default ErrorPage;
